import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "custom-form-dimension",
	template: `
		<div class="dynamic-field form-dimension" [formGroup]="group">
			<ic-form-dimension
				[formControlName]="config.name"
				[heightLabel]="config.label.height | language"
				[unit]="config.unit | language"
				[widthLabel]="config.label.width | language"
			/>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormDimensionComponent {
	@Input() config: any;
	// @ts-expect-error TS2564
	@Input() group: UntypedFormGroup;
}
